"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Permission;
    }
});
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let Permission = class Permission {
    static async list(context, baseId, _ncMeta = _Noco.default.ncMeta) {
        return [];
    }
    // placeholder for actual permission check logic
    static async isAllowed(_context, _permissionObj, _user) {
        return true;
    }
    constructor(permission){
        Object.assign(this, permission);
    }
};
